import React from 'react';
import '../styles/pages/LegalPages.css';

const TermsConditions = () => {
  return (
    <div className="legal-page">
      <div className="legal-hero">
        <h1>Terms & Conditions</h1>
        <p>Last Updated: January 30, 2026</p>
      </div>

      <div className="legal-container">
        <section className="legal-section">
          <h2>1. Acceptance of Terms</h2>
          <p>
            By accessing or using Local Customer Solution System ("LCS", "Platform"), you agree to be bound by these Terms and Conditions. If you do not agree, please discontinue use immediately.
          </p>
        </section>

        <section className="legal-section">
          <h2>2. Definitions</h2>
          <ul>
            <li><strong>"User"</strong>: Organizations or individuals registered on the Platform</li>
            <li><strong>"KYC Check"</strong>: Process of fetching credit information from authorized Company</li>
            <li><strong>"Wallet"</strong>: Prepaid digital wallet for service payments</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>3. Eligibility and Registration</h2>
          <ul>
            <li>Users must be registered businesses or authorized financial institutions</li>
            <li>Individual users must be 18+ years of age</li>
            <li>Users must provide accurate, complete information during registration</li>
            <li>One account per organization; duplicate accounts will be suspended</li>
            <li>Users are responsible for maintaining account confidentiality</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>4. Services Provided</h2>
          <p>LCS offers the following services:</p>
          <ul>
            <li>KYC Check and Analysis</li>
            <li>PAN Verification</li>
            <li>Court Case Check</li>
            <li>KYC Verification Services</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>5. User Obligations</h2>
          <ul>
            <li>Obtain proper consent from individuals before running credit checks</li>
            <li>Use services only for legitimate business purposes</li>
            <li>Comply with MCA guidelines, DPDP Act, and data protection laws</li>
            <li>Not share account credentials with unauthorized parties</li>
            <li>Maintain adequate wallet balance for uninterrupted service</li>
            <li>Report any security breaches or suspicious activity immediately</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>6. Prohibited Activities</h2>
          <p>Users must NOT:</p>
          <ul>
            <li>Run unauthorized credit checks without proper consent</li>
            <li>Use services for illegal activities or fraud</li>
            <li>Scrape, mine, or extract data from the Platform</li>
            <li>Reverse engineer, decompile, or hack the system</li>
            <li>Share or resell credit reports to third parties</li>
            <li>Upload false or misleading information</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>7. Wallet and Payments</h2>
          <ul>
            <li>Users must maintain sufficient wallet balance for KYC checks</li>
            <li>Wallet top-ups are non-refundable except in case of technical errors</li>
            <li>Pricing is subject to change with 30 days' notice</li>
            <li>Failed transactions due to insufficient balance will not be retried</li>
            <li>Wallet funds expire after 12 months of inactivity</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>8. Data Usage and Privacy</h2>
          <ul>
            <li>Credit reports are for single use and must not be redistributed</li>
            <li>Users must comply with data protection laws when handling credit information</li>
            <li>LCS is not responsible for users' misuse of credit data</li>
            <li>See our <a href="/privacy-policy">Privacy Policy</a> for detailed data practices</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>9. Service Availability</h2>
          <ul>
            <li>We strive for 99.5% uptime but do not guarantee uninterrupted service</li>
            <li>Scheduled maintenance will be notified 48 hours in advance</li>
            <li>Bureau downtimes may affect report generation (not under our control)</li>
            <li>We reserve the right to suspend service for security or maintenance</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>10. Disclaimer of Warranties</h2>
          <p>
            Services are provided "AS IS" without warranties of any kind. We do not guarantee:
          </p>
          <ul>
            <li>Accuracy of credit information (sourced from third-party bureaus)</li>
            <li>Availability of specific credit reports at all times</li>
            <li>Error-free or uninterrupted service</li>
            <li>Fitness for a particular purpose</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>11. Limitation of Liability</h2>
          <p>LCS shall not be liable for:</p>
          <ul>
            <li>Indirect, incidental, or consequential damages</li>
            <li>Loss of profits, data, or business opportunities</li>
            <li>Damages arising from third-party bureau errors</li>
            <li>User's misuse of credit information</li>
          </ul>
          <p>Total liability is limited to fees paid in the last 6 months.</p>
        </section>

        <section className="legal-section">
          <h2>12. Indemnification</h2>
          <p>
           Users agree to indemnify LCS against claims arising from:
          </p>
          <ul>
            <li>Violation of these Terms or applicable laws</li>
            <li>Unauthorized credit checks without proper consent</li>
            <li>Misuse of credit information obtained through the Platform</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>13. Termination</h2>
          <ul>
            <li>Users may terminate accounts by contacting support</li>
            <li>We may suspend or terminate accounts for Terms violations</li>
            <li>Upon termination, access is revoked immediately</li>
            <li>Wallet balances are forfeited if account is terminated for violations</li>
          </ul>
        </section>

        <section className="legal-section">
          <h2>14. Governing Law</h2>
          <p>
            These Terms are governed by the laws of India. Disputes will be resolved in courts of [City], India.
          </p>
        </section>

        <section className="legal-section">
          <h2>15. Changes to Terms</h2>
          <p>
            We may update these Terms with notice via email or platform notification. Continued use constitutes acceptance of updated Terms.
          </p>
        </section>

        <section className="legal-section">
          <h2>16. Contact Information</h2>
          <div className="contact-box">
            <p><strong>Legal Department</strong></p>
            <p>Email: <a href="mailto:info@lcsolution.in">info@lcsolution.in</a></p>
            <p>Support: <a href="mailto:support@lcsolution.in">support@lcsolution.in</a></p>
          </div>
        </section>
      </div>
    </div>
  );
};

export default TermsConditions;
